<div class="store-list-page" dir="rtl" data-testid="store-list-page"
  [class.phone-note]="phonePanel === 'note'"
  [class.phone-search]="phonePanel === 'search'"
  [class.phone-cart]="phonePanel === 'cart'"
  (touchstart)="onPanelTouchStart($event)"
  (touchmove)="onPanelTouchMove($event)"
  (touchend)="onPanelTouchEnd($event)"
  (touchcancel)="onPanelTouchEnd($event)">
  <header class="hero">
    @if (basket && isBasketClosed) {
    <div class="hero-copy">
      <button type="button" class="list-close" data-testid="store-list-close"
        (click)="toggleListClosed()" [disabled]="listCloseBusy">
        פתח מחדש
      </button>
    </div>
    }
    <button type="button" class="location-btn" (click)="openLocationSettings()"
      data-testid="store-list-location"
      [class.has-location]="hasSelectedLocation">
      {{ hasSelectedLocation ? selectedBranchLabel : 'בחירת עיר וסניף' }}
    </button>
  </header>

  @if (errorMessage) {
  <p class="message error" role="alert" data-testid="store-list-error">{{ errorMessage }}</p>
  }
  @if (statusMessage) {
  <p class="message status" role="status" data-testid="store-list-status">{{ statusMessage }}</p>
  }

  <div class="workspace-clip"
    [class.is-dragging]="panelDragging"
    [style.height.px]="slideHeight">
  <div class="workspace"
    [class.is-dragging]="panelDragging"
    [style.--panel-index]="panelIndex"
    [style.--drag-x]="panelDrag + 'px'">
    <main class="main-column" #searchPanel
      [attr.inert]="panelHidden('search') ? '' : null"
      [attr.aria-hidden]="panelHidden('search') ? true : null">
      <section class="card">
        <app-product-search
          [selectedCity]="selectedCity"
          [selectedBranchId]="selectedBranchId"
          [cameraAvailable]="cameraAvailable"
          [isBasketClosed]="isBasketClosed"
          [addingProductIds]="addingProductIds"
          [basketNeeds]="cartNeeds"
          [busyNeedIds]="busyNeedIds"
          (openLocationSettings)="openLocationSettings()"
          (addProduct)="addProduct($event.product, $event.quantity, $event.weightPhotoId)"
          (adjustQuantity)="adjustSearchQuantity($event.product, $event.quantity, $event.weightPhotoId)"
          (errorNotice)="errorMessage = $event"
        />
      </section>
    </main>

    <aside class="list-column">
      <section class="card note-card" #notePanel aria-labelledby="open-list-title" data-testid="open-list"
        [attr.inert]="panelHidden('note') ? '' : null"
        [attr.aria-hidden]="panelHidden('note') ? true : null">
        <div class="section-heading">
          <div class="note-heading-title">
            @if (renamingList) {
            <input #listNameInput id="open-list-title" type="text" class="list-rename-input"
              data-testid="store-list-name-input" [(ngModel)]="renameText"
              [ngModelOptions]="{standalone: true}"
              (keydown.enter)="$event.preventDefault(); saveListName()"
              (keydown.escape)="cancelRename()"
              (blur)="saveListName()"
              maxlength="60" autocomplete="off" dir="rtl" aria-label="שם הרשימה" />
            } @else {
            <h2 id="open-list-title" class="list-name-heading">
              @if (isBasketClosed) {
              {{ listTitle }}
              } @else {
              <button type="button" class="list-name" data-testid="store-list-name" (click)="startRename()"
                [appSavedField]="listNameSaved"
                [attr.aria-label]="'עריכת שם הרשימה, ' + listTitle">{{ listTitle }}</button>
              }
            </h2>
            }
          </div>
          <div class="heading-end">
            <span class="count-badge" [class.count-badge--pop]="listPulse">{{ openNeeds.length }}</span>
            <button type="button" class="btn-list-share" [class.is-shared]="basket?.groupId"
              data-testid="store-list-share" (click)="openShare()" [disabled]="sharePreparing"
              [attr.aria-label]="basket?.groupId ? 'שיתוף הרשימה (' + (basket?.groupName || 'קבוצה משותפת') + ')' : 'שיתוף הרשימה'"
              [title]="basket?.groupId ? 'משותף עם: ' + (basket?.groupName || 'קבוצה משותפת') : 'שיתוף הרשימה'">
              <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
              </svg>
            </button>
          </div>
        </div>
        <div class="note-composer">
          <input type="text" class="note-input" data-testid="list-composer-input" [(ngModel)]="noteText"
            (keydown.enter)="$event.preventDefault(); addNoteLines()" placeholder="חלב, פטרוזיליה, עגבניות" aria-label="פריט לרשימה"
            [disabled]="noteBusy || isBasketClosed" autocomplete="off" dir="rtl" />
          <button type="button" class="note-add" data-testid="list-composer-add" (click)="addNoteLines()"
            [disabled]="noteBusy || isBasketClosed || !noteText.trim()">
            {{ noteBusy ? 'מוסיף…' : 'הוספה' }}
          </button>
        </div>
        @if (basketLoading) {
        <p class="empty-state">טוען את הרשימה השמורה…</p>
        } @else if (openNeeds.length === 0) {
        <p class="empty-state">הרשימה ריקה. הוסיפו פריטים כמו חלב או עגבניות.</p>
        } @else {
        <ul class="note-list">
          @for (need of openNeeds; track need.id) {
          <li class="note-slot" [class.note-slot--enter]="enteringNeedIds.has(need.id)"
            [attr.data-need-id]="need.id" data-testid="open-list-item">
            <div class="note-row" [class.note-row--enter]="enteringNeedIds.has(need.id)"
              (click)="searchFromList(need)">
              <button type="button" class="note-words" data-testid="open-list-search" dir="auto"
                (click)="$event.stopPropagation(); searchFromList(need)"
                [attr.aria-label]="'חיפוש ' + lineText(need)">{{ lineText(need) }}</button>
              <button type="button" class="note-remove" (click)="$event.stopPropagation(); removeOpenNeed(need)"
                [disabled]="isBasketClosed || busyNeedIds.has(need.id)"
                [attr.aria-label]="'הסרת ' + lineText(need)">×</button>
            </div>
          </li>
          }
        </ul>
        }
      </section>

      <section class="card cart-card" #cartPanel aria-labelledby="cart-title" data-testid="cart-list"
        [attr.inert]="panelHidden('cart') ? '' : null"
        [attr.aria-hidden]="panelHidden('cart') ? true : null">
        <div class="section-heading">
          <h2 id="cart-title">מוצרים בסל הקניות</h2>
          <span class="count-badge" data-testid="store-cart-count">{{ cartCount }}</span>
        </div>
        @if (cartNeeds.length === 0) {
        <p class="empty-state">עדיין אין מוצרים בסל. חפשו או סרקו מוצר.</p>
        } @else {
        <ul class="cart-list">
          @for (need of cartNeeds; track need.id) {
          <li class="cart-row" [attr.data-need-id]="need.id">
            <div class="cart-main">
              @if (hasProductPhoto(need.lockedProductId)) {
              <button type="button" class="photo-btn" (click)="imagePopupProductId = need.lockedProductId"
                [attr.aria-label]="'הגדלת תמונה עבור ' + need.requestedText">
                <img [src]="productImageUrl(need.lockedProductId!)" alt=""
                  (error)="markImageBroken(need.lockedProductId!)" />
              </button>
              }
              <div class="cart-copy">
                <strong class="cart-title" dir="auto">{{ need.requestedText }}</strong>
                @if (need.listLabel) {
                <button type="button" class="list-badge" data-testid="list-badge" (click)="openBadgePicker(need)"
                  [disabled]="isBasketClosed" [attr.aria-label]="'סימון הרשימה: ' + need.listLabel">
                  {{ need.listLabel }}
                </button>
                }
                <div class="cart-meta">
                  @if (catalogPrice(need); as price) {
                  <span class="cart-price" [class.cart-price--weight]="!!need.soldByWeight">
                    @if (need.soldByWeight) {
                    @if (cartLineTotal(need); as line) {
                    <strong class="cart-line-total" data-testid="cart-line-total">{{ formatMoney(line, price.currency) }}</strong>
                    }
                    }
                    <span class="cart-unit">
                      @if (need.soldByWeight) {
                      <span class="qty-label">{{ formatQuantity(need.quantity) }} ק״ג ×</span>
                      } @else if (need.quantity > 1) {
                      <span class="qty-label">{{ formatQuantity(need.quantity) }} ×</span>
                      }
                      @if (price.promoPrice != null) {
                      <span class="struck">{{ formatMoney(price.price, price.currency) }}</span>
                      <span class="promo">{{ formatMoney(price.promoPrice, price.currency) }}</span>
                      } @else {
                      {{ formatMoney(price.price, price.currency) }}
                      }
                    </span>
                  </span>
                  } @else if (!selectedBranchId) {
                  <span class="muted">לא נבחר סניף</span>
                  } @else {
                  <span class="unstocked">לא נמכר בסניף זה</span>
                  }
                  <app-kg-quantity
                    [quantity]="need.quantity"
                    [soldByWeight]="!!need.soldByWeight"
                    [disabled]="isBasketClosed || busyNeedIds.has(need.id) || estimatingNeedIds.has(need.id)"
                    [estimating]="estimatingNeedIds.has(need.id)"
                    [label]="need.requestedText"
                    (quantityChange)="changeQuantity(need, $event)"
                    (photo)="estimateCartWeight(need, $event)"
                  />
                </div>
              </div>
              <button type="button" class="cart-remove" (click)="removeCartNeed(need)"
                [disabled]="isBasketClosed || busyNeedIds.has(need.id)"
                [attr.aria-label]="'הסרת ' + need.requestedText">×</button>
            </div>
          </li>
          }
        </ul>
        @if (cartTotal != null) {
        <p class="cart-total" data-testid="store-cart-total">
          <span>סך הכל</span>
          <strong>{{ formatMoney(cartTotal) }}</strong>
        </p>
        }
        }
      </section>
    </aside>
  </div>
  </div>

  <nav class="phone-tabs" aria-label="ניווט רשימה לסופר" role="tablist">
    <button type="button" class="phone-tab" role="tab" data-testid="store-phone-note"
      [class.phone-tab--selected]="phonePanel === 'note'" [attr.aria-selected]="phonePanel === 'note'"
      (click)="showPanel('note')">
      <span class="phone-tab-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
          <path d="M8 6h12M8 12h12M8 18h12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <path d="M4 6h.01M4 12h.01M4 18h.01" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
        </svg>
        @if (openNeeds.length > 0) {
        <span class="phone-tab-count" [class.count-bumped]="listPulse"
          [attr.aria-label]="openNeeds.length + ' פריטים ברשימה'">
          {{ openNeeds.length }}
        </span>
        }
      </span>
      <span>רשימה</span>
    </button>
    <button type="button" class="phone-tab" role="tab" data-testid="store-phone-search"
      [class.phone-tab--selected]="phonePanel === 'search'" [attr.aria-selected]="phonePanel === 'search'"
      (click)="showPanel('search')">
      <span class="phone-tab-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
          <circle cx="11" cy="11" r="6.5" fill="none" stroke="currentColor" stroke-width="2" />
          <path d="M16 16.5 20.5 21" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
      </span>
      <span>חיפוש</span>
    </button>
    <button type="button" class="phone-tab" role="tab" data-testid="store-phone-cart"
      [class.phone-tab--selected]="phonePanel === 'cart'" [attr.aria-selected]="phonePanel === 'cart'"
      (click)="showPanel('cart')">
      <span class="phone-tab-icon">
        <svg viewBox="0 0 24 24" width="24" height="24" aria-hidden="true" focusable="false">
          <path d="M6 7h15l-1.5 8.5H8L6 7Z" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linejoin="round" />
          <path d="M6 7 5 4H2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
          <circle cx="9" cy="20" r="1.25" fill="currentColor" />
          <circle cx="18" cy="20" r="1.25" fill="currentColor" />
        </svg>
        @if (cartCount > 0) {
        <span class="phone-tab-count" data-testid="phone-cart-count"
          [attr.aria-label]="cartCount + ' פריטים בסל'">
          {{ cartCount }}
        </span>
        }
      </span>
      <span>סל</span>
    </button>
  </nav>

  @if (picker) {
  <div class="picker-backdrop" (click)="cancelPicker()">
    <div class="picker-sheet" role="dialog" aria-modal="true" aria-labelledby="picker-title"
      data-testid="list-match-picker" (click)="$event.stopPropagation()">
      <h3 id="picker-title">זה הפריט מהרשימה?</h3>
      @if (openNeeds.length > 0) {
      <ul class="picker-options">
        @for (line of openNeeds; track line.id) {
        <li>
          <button type="button" data-testid="list-match-option" (click)="chooseOpenLine(line)" [disabled]="pickerBusy">
            {{ lineText(line) }}
          </button>
        </li>
        }
      </ul>
      }
      <div class="picker-actions">
        <button type="button" data-testid="list-match-none" (click)="chooseNotFromList()" [disabled]="pickerBusy">
          לא מהרשימה
        </button>
        <button type="button" data-testid="list-match-cancel" (click)="cancelPicker()" [disabled]="pickerBusy">
          ביטול
        </button>
      </div>
    </div>
  </div>
  }

  @if (imagePopupProductId; as photoId) {
  <div class="photo-popup" role="dialog" aria-modal="true" aria-label="תמונת מוצר מוגדלת"
    (click)="imagePopupProductId = null">
    <button type="button" class="photo-close" aria-label="סגור תמונה" (click)="imagePopupProductId = null">×</button>
    <img [src]="productImageUrl(photoId)" alt="" />
  </div>
  }

  <app-location-selector-modal
    [isOpen]="locationSettingsOpen"
    [cities]="cities"
    [selectedCity]="selectedCity"
    [citiesLoading]="citiesLoading"
    [branches]="branches"
    [selectedBranchId]="selectedBranchId"
    [branchesLoading]="branchesLoading"
    (close)="closeLocationSettings()"
    (cityChange)="onCityChange($event)"
    (branchChange)="onBranchChange($event)"
  />

  <app-group-share-modal
    [isOpen]="shareGroupOpen"
    [basket]="basket"
    [selectedCity]="selectedCity"
    [selectedBranchId]="selectedBranchId"
    shareTitle="שיתוף הרשימה לסופר"
    whatsappIntro="היי! שיתפתי איתך רשימה לסופר ב-Commpare:"
    linkPage="store-list"
    (close)="closeShare()"
    (basketUpdated)="onBasketShared($event)"
    (statusNotice)="statusMessage = $event"
  />
</div>
